<template>
  <v-snackbar 
    v-model="show" 
    :top="top" 
    :color="color"
    :right="right"
    :timeout="timeout"
    app
  >
    {{ message }}
    <template v-slot:action="{ attrs }">
      <v-btn
        color="white"
        dark
        text
        v-bind="attrs"
        @click="show = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  // EVENTS
  import { RESET_SNACK } from '@/store/actions/snackbar'
  
  export default {
    data: () => ({
      show: false,
      top: false,
      right: true,
      message: '',
      color: '',
      timeout: 5000
    }),

    created() {
      this.$store.watch(
        state => state.snackbar.snack,
        () => {
          const message = this.$store.state.snackbar.snack.message
          if (message) {
            this.show = true
            this.message = message

            this.color = this.$store.state.snackbar.snack.color
            this.$store.commit(RESET_SNACK)
          }
        }
      )
    }
  }
</script>